/* eslint-disable array-callback-return */
import React, { useEffect, useState, useRef, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

import TopInput from "./TopInput";
import {
  attendanceActions,
  locationActions
} from "../../../redux/actions";
import { helperFunction } from "../../../constant/helper";
import UserList from "./UserList";
import {
  advancedFilterWorker,
  tableSkeleton
} from "../../../constant/helper/helper";
import useSortableData from "../../../customHooks/sortingHooks";
import { tableHeaderData } from "./attendanceStaticData";
import TableHeader from "../../../component/tableHeader/TableHeader";
import isEmpty from "../../../validation/isEmpty";
import { types } from "../../../redux/type";
import Starter from "../../../component/Starter";
import Card from "../../../component/card/Card";
import { getAllZones } from "../../../redux/actions/hrActions";

const initialState = {
  Filter: "",
  locationId: "",
  date: "",
  onOffLocation: false,
  byTime: "inTimeDescending"
};

const DailyAttendance = () => {
  const componentRef = useRef();
  const loginType = localStorage.loginType;
  const dispatch = useDispatch();
  const [zoneData, setZoneData] = useState([]);
  const [zone, setZone] = useState("");
  const [dailyArray, setDailyArray] = useState([]);
  const [values, setValues] = useState(initialState);
  const [allLocations, setAllLocations] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);

  const { locationError, locations } = useSelector(
    (state) => state.location
  );
  const { currentUser } = useSelector((state) => state.auth);
  const { allZones } = useSelector((state) => state.hr);

  const {
    date,
    locationId,
    attendanceError,
    dailyAttendances,
    attendanceLoading,
    selectedInputs
  } = useSelector((state) => state.attendance);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "onOffLocation") {
      setValues({
        ...values,
        onOffLocation: !values.onOffLocation
      });
    } else {
      setValues({
        ...values,
        [name]: value
      });
    }
  };

  useEffect(() => {
    setValues({
      ...values,
      date,
      locationId
    });
  }, [date, locationId]);

  useEffect(() => {
    if (!isEmpty(dailyAttendances)) {
      setDailyArray(dailyAttendances);
    }
  }, [dailyAttendances]);

  useEffect(() => {
    if (locationError) {
      helperFunction.toastHelper("error", locationError);
    }
    if (attendanceError) {
      helperFunction.toastHelper("error", attendanceError);
    }
  }, [locationError, attendanceError]);

  useEffect(() => {
    if (locations !== null) {
      setAllLocations(locations);
    } else {
      setAllLocations([]);
    }
  }, [locations]);

  useEffect(() => {
    if (!isEmpty(allZones)) {
      setZoneData(allZones);
    } else {
      setZoneData([]);
    }
  }, [allZones]);

  useEffect(() => {
    dispatch(getAllZones(loginType));
  }, []);

  useEffect(() => {
    if (selectedInputs !== null) {
      setSelectedCategory(selectedInputs);
    } else {
      setSelectedCategory([]);
    }
  }, [selectedInputs]);

  useEffect(() => {
    dispatch(locationActions.clearLocationErrors());
    dispatch(locationActions.clearLocationResult());
    dispatch(attendanceActions.clearAttendanceErrors());
    dispatch(attendanceActions.clearAttendanceResult());
    return () => {
      dispatch(locationActions.clearLocationErrors());
      dispatch(locationActions.clearLocationResult());
      dispatch(attendanceActions.clearAttendanceErrors());
      dispatch(attendanceActions.clearAttendanceResult());
    };
  }, []);

  const defaultValueFunction = () => {
    const selectedChoice = {};
    selectedCategory.map((i) => {
      selectedChoice[i.value] = 1;
    });

    const newObject = {
      Date: 1,
      inTime: 1,
      outTime: 1,
      duration: 1,
      createdAs: 1,
      inCreatedAs: 1,
      outCreatedAs: 1,
      detections: 1,
      isOutDoorDuty: 1,
      workerId: 1,
      inTimeHistory: 1,
      outTimeHistory: 1,
      regularizationStatus: 1
    };
    Object.keys(selectedChoice).forEach(function (key) {
      newObject[key] = selectedChoice[key];
    });

    return JSON.stringify(newObject);
  };

  // fetch daily attendance
  const fetchDailyAttendance = (e) => {
    e.preventDefault();
    const dataToGetDailyAttendance = defaultValueFunction();
    dispatch(attendanceActions.setAttendanceLoading(true));
    dispatch(attendanceActions.clearAttendanceErrors());
    dispatch(attendanceActions.clearAttendanceResult());
    const empty = isEmpty(loginType);
    if (empty) {
      const errorData = {
        data: { message: "PLEASE LOGOUT AND LOGIN AGAIN" },
        status: 401
      };
      dispatch({
        type: types.AttendanceTypes.ATTENDANCE_GET_ERRORS,
        payload: errorData
      });
    } else {
      dispatch(
        attendanceActions.getDailyAttendance(
          values.date,
          values.locationId,
          loginType,
          dataToGetDailyAttendance,
          selectedCategory
        )
      );
    }
  };

  // show user list
  const showUserList = (sortedArray) => {
    if (attendanceLoading) {
      return <tr>{tableSkeleton(11 + selectedCategory.length)}</tr>;
    } else if (sortedArray === null) {
      return (
        <tr style={{ top: "50%", left: "50%", position: "fixed" }}>
          <td>
            <span className="">Please Select Locations and Date</span>
          </td>
        </tr>
      );
    } else if (sortedArray.length === 0) {
      return (
        <tr
          style={{
            top: "50%",
            left: "50%",
            position: "absolute",
            transform: "translate(-50%, -50%)"
          }}
        >
          <td>
            <span className="">
              No Record Found for date {values.date}
            </span>
          </td>
        </tr>
      );
    } else if (!isEmpty(sortedArray) && sortedArray.length > 0) {
      let newSortedArray = sortedArray;
      if (!isEmpty(zone)) {
        newSortedArray = sortedArray.filter((filterWorker) => {
          return filterWorker.zoneId.indexOf(zone) !== -1;
        });
      }

      const filteredUser = advancedFilterWorker(
        newSortedArray,
        values.Filter,
        "fullNameAndId"
      );

      return filteredUser.map(
        (filterWorkerDailyAttendance, index) => (
          <UserList
            key={index}
            values={values}
            parentIndex={index}
            dailyAttendance={filterWorkerDailyAttendance}
            zone={zone}
          />
        )
      );
    }
  };

  const { items, requestSort, sortConfig } =
    useSortableData(dailyArray);

  const renderDynamicHeader = (selectedValues) => {
    return selectedValues?.map(
      (headerDynamic, dynamicHeaderIndex) => {
        return (
          <th key={dynamicHeaderIndex}>{headerDynamic.label}</th>
        );
      }
    );
  };

  // return main render
  return (
    <Starter
      topBarTitle="Daily Attendance"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Attendance Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Attendance</a>
          </li>
          <li className="breadcrumb-item active">Daily Attendance</li>
        </Fragment>
      }
    >
      <Card>
        <TopInput
          values={values}
          currentUser={currentUser}
          loading={attendanceLoading}
          onChange={handleInputChange}
          onSubmit={fetchDailyAttendance}
          selectedCategory={selectedCategory}
          handleSelectCategories={(input) =>
            setSelectedCategory(input)
          }
          allLocations={
            typeof allLocations !== "undefined" &&
            allLocations.length > 0
              ? allLocations
              : []
          }
          zoneData={zoneData}
          zone={zone}
          setZone={(e) => setZone(e.target.value)}
        />
        <div
          className="table-responsive"
          ref={componentRef}
          style={{
            height: "700px",
            overflow: "auto",
            position: "relative"
          }}
        >
          <table
            className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
            id="products-datatable"
          >
            <thead className="thead-light">
              <tr>
                <th style={{ width: "20px" }}>#</th>
                <th style={{ width: "80px" }}>Date</th>
                <TableHeader
                  tableHeaderData={tableHeaderData}
                  requestSort={requestSort}
                  sortConfig={sortConfig}
                />
                {renderDynamicHeader(selectedCategory)}
                <th className="text-center">Hours</th>
                <th className="text-center">IN-OUT</th>
                <th className="text-center">Status</th>
                <th className="text-center">Regul-Status</th>
                {values.onOffLocation ? (
                  <th className="text-center">Actions</th>
                ) : null}
              </tr>
            </thead>
            <tbody>{showUserList(items)}</tbody>
          </table>
        </div>
      </Card>
      <div className="row mt-3">
        <div className="col-sm-1"></div>
        <div className="col-sm-4"></div>
        <div className="col-2">
          <ReactHTMLTableToExcel
            className="btn btn-dark btn-block"
            table="products-datatable"
            filename={`${values.date}`}
            sheet="Sheet"
            buttonText="Export excel"
          />
        </div>
        <div className="col-sm-1"></div>
        <div className="col-sm-4"></div>
      </div>
    </Starter>
  );
};

export default DailyAttendance;
